module.exports = __webpack_public_path__ + "static/media/green-tick.d17d7552.svg";